import { asType } from '@sparky/framework'
import { ActivationManifest, PrimaryAppIds } from '../renderer'
import { CSP_LEARN_MORE_LINK } from '../constants'

export default asType<ActivationManifest>({
  activation_id: 'ademx',
  description: 'ADEM',
  primary_app_id: PrimaryAppIds.ADEM,
  flags: {
    hash_required: true,
    cdl_required: true,
    amend_license: true
  },
  activation_screens: [
    {
      key: 'activate',
      component: 'activation.UDefaultActivationScreen',
      props: {
        title: '',
        description: '',
        primaryButton: {
          text: 'Activate Now',
        },
        children: [
          {
            key: 'screen-header',
            component: 'activation.UScreenHeader',
            props: {
              title: 'Activate Subscription',
              headerAppId: 'ademx'
            }
          },
          {
            key: 'activation-form',
            component: 'activation.UDefaultActivationForm',
            props: {
              title: '',
              subTitle: '',
              children: [
                {
                  key: 'activation-section-csp',
                  component: 'activation.UActivationSection',
                  props: {
                    title: 'Select Customer Support Account',
                    subtitle: 'This account is used for the registration and support of the products and add-ons that are bundled with this subscription.',
                    link: CSP_LEARN_MORE_LINK,
                    children: [
                      {
                        key: 'activation-accordion-csp',
                        component: 'activation.UAccordion',
                        props: {
                          title: 'Customer Support Account:',
                          children: [
                            {
                              key: 'default-dropdown-component-csp',
                              component: 'activation.UCSPComponent',
                              props: {
                              },
                            },
                          ]
                        }
                      },
                    ]
                  }
                },
                {
                  key: 'activation-section-subscription',
                  component: 'activation.UActivationSection',
                  props: {
                    title: 'Allocate This Subscription',
                    subtitle: 'Allocate some or all of the available licenses and add-ons in this subscription to a recipient.',
                    children: [
                      {
                        key: 'activation-accordion-tsg',
                        component: 'activation.UAccordion',
                        props: {
                          title: 'Recipient:',
                          children: [
                            {
                              key: 'default-tsg-component',
                              component: 'activation.UTSGComponent',
                              props: {
                              }
                            },
                          ]
                        }
                      },
                      {
                        key: 'activation-accordion-region',
                        component: 'activation.UAccordion',
                        props: {
                          title: 'Region:',
                          children: [
                            {
                              key: 'default-region-component',
                              component: 'activation.URegionComponent',
                              props: {
                              }
                            },
                          ]
                        }
                      },
                      {
                        key: 'activation-accordion-sase',
                        component: 'activation.UAccordion',
                        props: {
                          children: [
                            {
                              key: 'activation-adem-component',
                              component: 'adem-activation.ADEMLicenseAllocation',
                              props: {
                              }
                            },
                          ]
                        }
                      },
                      {
                        key: 'activation-accordion-cdl',
                        component: 'activation.UAccordion',
                        props: {
                          title: 'Cortext Data Lake',
                          children: [
                            {
                              key: 'default-cdl-component',
                              component: 'activation.UCDL',
                              props: {
                                enableMigration: true,
                                isUnifiedDisplay: true,
                                title: 'Add Cortex Data Lake',
                                cdlDropDownProps: {
                                  display: {
                                    errorMessage: 'Select CDL to proceed activation',
                                    subTitle: 'CDL instance for this tenant'
                                  },
                                  dropDownProps: {
                                    required: true,
                                    triggerValidationOnChange: true,
                                  },
                                  size: {
                                    height: 32,
                                    width: 300
                                  },
                                  passByProps: {
                                    // disabled: true,
                                    dataTestId: 'cdl-activation-screen',
                                    enableSearch: true,
                                    label: 'Cortex Data Lake',
                                    placeholder: 'Select CDL Instance',
                                  }
                                }
                              }
                            },
                          ]
                        }
                      },
                      {
                        key: 'activation-accordion-cie',
                        component: 'activation.UAccordion',
                        props: {
                          title: 'Cloud Identity Engine',
                          hasDoneButton: true,
                          children: [
                            {
                              key: 'default-cie-field',
                              component: 'activation.DefaultCIEField',
                              props: {
                                group: 1,
                                cieDropDownProps: {
                                  display: {
                                    errorMessage: 'Select CIE to proceed activation',
                                    subTitle: 'CIE instance for this tenant'
                                  },
                                  dropDownProps: {
                                    required: false,
                                    triggerValidationOnChange: true,
                                  },
                                  size: {
                                    height: 32,
                                    width: 355
                                  },
                                  passByProps: {
                                    dataTestId: 'cie-activation-screen',
                                    enableSearch: false,
                                    label: '',
                                    placeholder: 'Select CIE Instance',
                                  }
                                }
                              }
                            }
                          ]
                        }
                      },
                    ]
                  }
                },
                {
                  key: 'form-footer',
                  component: 'activation.FormFooter',
                  props: {
                    group: 3,
                    buttonText: 'Activate',
                    dataTestId: 'activate-button'
                  }
                },
              ],
            }
          },
          {
            key: 'screen-footer',
            component: 'activation.ScreenFooter',
            props: {
            }
          }
        ],
      }
    }
  ],
})
